import * as React from 'react'
import {
  Container,
  MainHeading,
  ServiceProductListContainer,
  SummaryContainer,
} from '../styled'
import { ServiceProductsSummary } from '../ServiceProductsSummary'
import { ServiceLocationCardDetail } from '../ServiceLocationCardDetail/ServiceLocationCardDetail'
import { ENTITY_TYPES, LocationDTO } from '@sales-center/common'
import { ILeadOppProduct } from '@user/store/leadOppProducts'
import { IServiceFrequency } from '@user/store/serviceFrequency'
import { Props as ServicesProps } from '../Services'

type Props = Pick<
  ServicesProps,
  | 'minimumServicesCount'
  | 'deleteServiceWarningMessage'
  | 'readOnly'
  | 'totalServicesCount'
  | 'createNewOpp'
> & {
  disabled: boolean
  entityType: ENTITY_TYPES
  loading: boolean
  localMode: boolean
  onAddClick: () => void
  onEditClick: (service: ILeadOppProduct) => void
  onSaveServicesForLaterClick: () => void
  serviceFrequencies: IServiceFrequency[]
  serviceLocations: LocationDTO[]
  tabletView: boolean
  isClosedEntity: boolean
}

export function VerboseContent(props: Props) {
  const {
    deleteServiceWarningMessage,
    disabled,
    entityType,
    loading,
    localMode,
    minimumServicesCount,
    onAddClick,
    onEditClick,
    onSaveServicesForLaterClick,
    readOnly,
    serviceFrequencies,
    serviceLocations,
    totalServicesCount,
  } = props

  return (
    <Container>
      <ServiceProductListContainer>
        <>
          <MainHeading>Services / Products Added</MainHeading>
          {serviceLocations.map((s) => (
            <ServiceLocationCardDetail
              defaultExpanded
              location={s}
              key={localMode ? s.externalLinkId : s.id}
              entityType={entityType}
              onEditClick={onEditClick}
              serviceFrequencies={serviceFrequencies}
              minimumServicesCount={minimumServicesCount}
              deleteServiceWarningMessage={deleteServiceWarningMessage}
              localMode={localMode}
              disabled={loading || disabled}
              readOnly={readOnly}
              loading={loading}
              showReorderServices={true}
              totalServicesCount={totalServicesCount}
              variant="new"
            />
          ))}
        </>
      </ServiceProductListContainer>
      <SummaryContainer>
        <ServiceProductsSummary
          {...props}
          addServiceButtonClick={onAddClick}
          saveServicesForLaterClick={onSaveServicesForLaterClick}
          totalServicesCount={totalServicesCount}
        />
      </SummaryContainer>
    </Container>
  )
}
